/**
 * Controller for the Invigilator Menu Pause Modal.
 * This class handles the logic for pausing tasks and logging events.
 * 
 * @class
 * @param {Object} $scope - AngularJS scope object.
 * @param {Object} $uibModalInstance - Instance of the modal dialog.
 * @param {Object} taskCountdownService - Service for managing task countdowns.
 * @param {Object} $eventLog - Service for logging events.
 * @param {Object} $translate - Service for translation.
 */
export default class InvigilatorMenuPauseModalController {
    constructor($scope, $uibModalInstance, taskCountdownService, $eventLog, $translate) {
        /**
         * AngularJS scope object.
         * @type {Object}
         */
        this.$scope = $scope;

        /**
         * Instance of the modal dialog.
         * @type {Object}
         */
        this.$uibModalInstance = $uibModalInstance;

        /**
         * Service for managing task countdowns.
         * @type {Object}
         */
        this.taskCountdownService = taskCountdownService;

        /**
         * Service for logging events.
         * @type {Object}
         */
        this.$eventLog = $eventLog;

        /**
         * Service for translation.
         * @type {Object}
         */
        this.$translate = $translate;


        $scope.invigilatorRequired = taskCountdownService.invigilatorRequired() !== null ? taskCountdownService.invigilatorRequired() : true;

        // Bind the onConfirm method to the current instance
        $scope.onConfirm = this.onConfirm.bind(this);
    }

    /**
     * Handles the confirmation action when the user confirms the pause.
     * 
     * @method
     */
    onConfirm() {

        // Set the invigilator required status in the task countdown service
        this.taskCountdownService.setInvigilatorRequired(this.$scope.invigilatorRequired);

        // Log the event based on the event type reason
        if (this.$scope.eventTypeReason) {
            this.$eventLog.logEvent(this.$translate.instant("MODULES.ADMIN.EVENTLOG_PAUSE_BY_INVIGILATOR"), "pauseByInv", this.$scope.eventExplanation, this.$scope.eventTypeReason, {});
        } else {
            this.$eventLog.logEvent(this.$translate.instant("MODULES.ADMIN.EVENTLOG_PAUSE_BY_INVIGILATOR"), "pauseByInv", this.$scope.eventExplanation, '', {});
        }

        // Set the modal confirmation status
        this.$uibModalInstance.confirm = true;

        // Close the modal
        this.$uibModalInstance.close();
    }
}